import { Divider } from "@/atoms"

import styles from "./Descriptions.module.scss"

export const DividerDescription = () => (
  <Divider className={styles.divider} data-id="divider" />
)
